export function getRemainingTimeRatio(startTimestampMs, totalMs, nowMs = performance.now()) {
    const elapsedMs = nowMs - startTimestampMs;
    return Math.max(0, totalMs - elapsedMs) / totalMs;
}
